/** Перечисление сред выполнения */
export enum EnvType {
  DEVELOPMENT = 'dev',
  PRODUCTION = 'prod',
  RELEASE_CANDIDATE = 'rc',
  LOCAL = 'local',
  STABLE = 'stable'
}